module.exports = __webpack_public_path__ + "static/music-4f4e763359b3388fa50b013ac125ac5d.png";